import { BaseType } from '../../base/base-type';

export class DesignatedUnitContributionRateBasisType extends BaseType {}
